module.exports = __webpack_public_path__ + "assets/a735dc20f8f8396c08eeda53a445ba93.mp4";